import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useAudio } from '../../context/AudioContext';
import './Home.css';

const Home = () => {
  const { startMusic } = useAudio();
  
  // List of image sources
  const sources = [
    '/images/hero img/table3.jpg',
    '/images/hero img/table4.jpg',
    '/images/hero img/table5.jpg',
    '/images/hero img/table6.jpg',
    '/images/hero img/table7.jpg',
    '/images/hero img/table8.jpg',
  ];

  const [index, setIndex] = useState(0);

  // Set initial random index
  useEffect(() => {
    setIndex(Math.floor(Math.random() * sources.length));
  }, [sources.length]);

  // Set interval for changing images
  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % sources.length);
    }, 60000);

    return () => clearInterval(intervalId);
  }, [sources.length]);

  // Lightbox state
  const [showLightbox, setShowLightbox] = useState(false);

  useEffect(() => {
    // Only show the lightbox if not already closed this session
    if (!sessionStorage.getItem('welcomeVideoClosed')) {
      setShowLightbox(true);
    } else {
      // If lightbox was already closed this session, start music
      setTimeout(async () => {
        await startMusic();
      }, 500);
    }
  }, [startMusic]);

  const handleCloseLightbox = async () => {
    setShowLightbox(false);
    sessionStorage.setItem('welcomeVideoClosed', 'true');
    
    // Start background music after welcome video closes
    setTimeout(async () => {
      await startMusic();
    }, 500);
  };

  return (
    <>
      {/* Hero Section with Crossfading Background Images */}
      <section className="hero">
        <div className="hero-background-container">
          {sources.map((src, i) => {
            let className = '';
            if (i === index) {
              className = 'fadeIn';
            } else if (i === (index - 1 + sources.length) % sources.length) {
              className = 'fadeOut';
            }
            return (
              <img
                key={src}
                src={src}
                alt={`Hero Background ${i + 1}`}
                className={`hero-bg-image ${className}`}
              />
            );
          })}
        </div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="ministry-title">
            <h1 className="hero-title">Prophetic Roundtable</h1>
            <div className="ministry-subtitle">Ministries</div>
          </div>
          <p className="hero-text">
            Everyone has a voice at the table
          </p>
        </div>
      </section>

      {/* YouTube Video Section */}
      <section className="mission-section">
        <Container>
          <div className="video-container">
            <div className="responsive-video">
              <iframe
                src="https://www.youtube-nocookie.com/embed/l4mVUbGTqi4"
                title="Welcome to Prophetic Roundtable Ministries"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </Container>
      </section>

      {/* Lightbox Modal for Welcome Video */}
      {showLightbox && (
        <div className="welcome-lightbox-overlay">
          <div className="welcome-lightbox-modal">
            <button
              onClick={handleCloseLightbox}
              aria-label="Close"
              className="welcome-lightbox-close"
            >
              &times;
            </button>
            <div className="responsive-video">
              <iframe
                src="https://www.youtube-nocookie.com/embed/l4mVUbGTqi4?autoplay=1"
                title="Welcome to Prophetic Roundtable Ministries"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  borderRadius: '8px',
                }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home; 